module.exports = __webpack_public_path__ + "static/media/home-bg.d9ca7d14.png";